// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { containerStyles } from "@guestsupply/Overrides/Widgets/CheckoutShipping/CheckoutShippingPageContainer";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

containerStyles;

containerStyles.loadingOverlay = {
    css: css`
        width: 100%;
    `,
};
containerStyles.headerGridItem = { width: 12 };
containerStyles.approverInfoGridItem = {
    width: 12,
    css: css`
        padding: 0 15px;
    `,
};
containerStyles.cartTotalGridItemNarrow = { width: [12, 12, 0, 0, 0] };
containerStyles.fulfillmentMethodAndAddressesGridItem = { width: [12, 12, 6, 8, 8] };
containerStyles.fulfillmentMethodAndNotesGridItem = { width: 12 };
containerStyles.fulfillmentMethodGridItem = { width: [12, 12, 12, 6, 6] };
containerStyles.notesGridItemWide = { width: [0, 0, 0, 6, 6] };
containerStyles.addressesGridItem = { width: 12 };
containerStyles.notesAndCartTotalGridItem = { width: [12, 12, 6, 4, 4] };
containerStyles.notesGridItemNarrow = { width: [12, 12, 12, 0, 0] };
containerStyles.cartTotalGridItemWide = { width: [0, 0, 12, 12, 12] };
containerStyles.checkoutShippingPageTemplateStyles = {
    container: {
        css: css`
            margin-top: 10px;
        `,
    },
};
containerStyles.checkoutShippingTotalWrapper = {
    css: css`
        width: 100%;
    `,
};
containerStyles.stepperContainer = {
    css: css`
        margin-bottom: 20px;
    `,
};
